module.exports = __webpack_public_path__ + "img/ios.c4707dd9.jpg";